import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import skuSlice from './slices/skuSlice'
import packingSlice from './slices/packingSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    sku: skuSlice,
    packing: packingSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch